'use client';

import { CompanyLogoAndName } from '@componentsroot/CompanyLogoAndName';
import { Paper, Stack, Theme, Typography } from '@mui/material';

export function VerificationRequestedBy({
  url,
  organisationName,
  title = 'Verification requested by',
}: Readonly<{
  url: string;
  organisationName: string;
  title?: string;
}>) {
  if (!url && !organisationName) {
    return null;
  }

  return (
    <Paper sx={{ width: '100%' }}>
      <Stack
        sx={(theme: Theme) => ({
          padding: theme.semantic.spacing.base,
          gap: theme.semantic.spacing.xs,
          height: '100%',
        })}
      >
        <Typography variant="subtitle2">{title}</Typography>
        <CompanyLogoAndName companyName={organisationName} companyLogoUrl={url} />
      </Stack>
    </Paper>
  );
}
